<div class="container-fluid d-flex flex-column">
    <div class="row">
        <div class="col-12">
            <h1>{{data.title}}</h1>
        </div>
        <div class="col-12">
            {{data.message}}
        </div>
    </div>
    <div class="row align-items-end buttons-wrapper">
        <div class="col-12 offset-md-6 col-md-6">
            <button class="btn-edp btn-edp-primary w-100" (click)="close()">Confirmar</button>
        </div>
    </div>
</div>
